
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/overview",
      function () {
        return require("private-next-pages/workspace-management/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/overview"])
      });
    }
  